import React from 'react'
import './OurExecutiveCommittee.css'
import Box from '@mui/material/Box';
import { officeBearersData, exOfficioMembersData } from '../../../constant/constant'

const OurExecutiveCommittee = () => {
    return (
        <div className='ourExecutiveCommittee-containter'>
            <Box className="pt-5">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">Our National Executive Committee</h2>
                    <h6 className="text-center text-light pb-3 mt-0">(April 2026 – March 2028)</h6>
                </div>
                <div maxWidth="lg" className='p-md-5 p-3 overallPadding'>
                    <div className="chapter-heading d-flex py-2 justify-content-center align-items-center mb-4">
                        <h5 className="m-0 fw-bold text-light">Office-bearers</h5>
                    </div>
                    <div className='row d-flex justify-content-center'>
                        {officeBearersData.map((data, i) => {
                            return (
                                <div className='col-xl-3 col-lg-4 col-md-6 mb-3' key={i}>
                                    <div className='eltaiMember-containter'>
                                        <div className='card eltaimember-details-important-person mb-5 '>
                                            <h6 className='text-center signika-font eltaimember-details-important-person-name'>{data.name}</h6>
                                            <h6 className='text-center signika-font fw-bold' style={{ color: '#135c24' }}>{data.role}</h6>
                                            <p className='text-center signika-font m-0 eltaimember-details-important-person-address'>{data.Address}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div style={{ backgroundColor: '#135c24', color: 'white', padding: '5px' }} className="text-center w-100 mb-4 mt-4">
                        <h5 className="m-0 fw-bold">Ex Officio Executive Members</h5>
                    </div>
                    <div className='row d-flex justify-content-center'>
                        {exOfficioMembersData.map((data, i) => {
                            return (
                                <div className='col-xl-3 col-lg-4 col-md-6 mb-3' key={i}>
                                    <div className='eltaiMember-containter'>
                                        <div className='card eltaimember-details-important-person mb-5 '>
                                            <h6 className='text-center signika-font eltaimember-details-important-person-name'>{data.name}</h6>
                                            <h6 className='text-center signika-font fw-bold' style={{ color: '#135c24' }}>{data.role}</h6>
                                            <p className='text-center signika-font m-0 eltaimember-details-important-person-address'>{data.Address}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    {/* <h2 className='title-font text-center  fw-bold  past-office-beaer'>PAST OFFICE BEARERS</h2>
                    <h2 className='title-font text-center  fw-bold mt-3 presidents-OEC'>Presidents</h2>
                    <div className='row mt-5 mb-5'>
                        {Presidents.map((data, i) => {
                            return (
                                <div className='col-md-2 mb-4' key={i}>
                                    <div className={`presidentcard${data.id} m`}>
                                        <div className='presidents-dot'></div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <div className={`president-line${data.id}`}></div>
                                    </div>
                                    <h6 className='signika-font m-0 president-name'>{data.Name}</h6>
                                    <p className='signika-font m-0 president-year'>{data.years}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div maxWidth="lg" >
                    <h2 className='title-font text-center fw-bold presidents-OEC'>Secretaries</h2>
                    <div className='row mt-5  d-flex justify-content-center secretaries-container'>
                        {Secretaries.map((data, i) => {
                            return (
                                <div className='col-md-2 mb-5' key={i}>
                                    <div className={`presidentcard${data.id}`}>
                                        <div className='presidents-dot'></div>
                                    </div>
                                    <div className="d-flex justify-content-center ">
                                        <div className={`president-line${data.id}`}></div>
                                    </div>
                                    <h6 className='signika-font m-0 president-name'>{data.Name}</h6>
                                    <p className='signika-font m-0 president-year'>{data.years}</p>
                                </div>
                            )
                        })}
                    </div> */}
                </div>
            </Box>
        </div>
    )
}

export default OurExecutiveCommittee